import React from 'react';

/**
 * ComponentErrorBoundary
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {React.ReactNode} props.fallback
 * @returns {React.ReactNode}
 * @constructor
 * @description
 * A React component that catches JavaScript errors anywhere in its child component tree, logs those errors, and displays a fallback UI instead of the component tree that crashed.
 * Error boundaries catch errors during rendering, in lifecycle methods, and in constructors of the whole tree below them.
 * @see https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
 *
 * @example
 * <ComponentErrorBoundary fallback={<Typography>Error</Typography>}>
 * 	<SomeComponent />
 * </ComponentErrorBoundary>
 */

class ComponentErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	render() {
		if (this.state.hasError) {
			return this.props.fallback;
		}

		return this.props.children;
	}
}

export default ComponentErrorBoundary;
